import {
  Box,
  Button,
  Card,
  Container,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Grid,
  Typography,
  CircularProgress,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { ErrorMessage, Form, Formik } from "formik";
import DialogTitle from "@mui/material/DialogTitle";
import {
  DataGrid,
  GridColDef,
  GridRenderCellParams,
  GridToolbar,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import {
  useAddManufacturerMutation,
  useEditManufacturerMutation,
  useDeleteManufacturerMutation,
  useGetCatalogMfrsWithProductCountQuery,
} from "../redux/reducer/features/Product/productSlice";
import {
  CatalogManufacturerResponse,
  ManufacturerValidationSchema,
  ProductManufacturer,
} from "../models/features/Product/Product";
import ManufacturerImageDialog from "../compenents/products/ManufacturerImageDialog";

export interface ManufacturerProps {}

export const Manufacturer: React.FunctionComponent<ManufacturerProps> = () => {
  const { data, isLoading, isSuccess, refetch, status } =
    useGetCatalogMfrsWithProductCountQuery();
  const [manufacturerMutation, manufacturerMutationResult] =
    useAddManufacturerMutation();
  const [selectedRow, setSelectedRow] = React.useState<ProductManufacturer>();
  const [selectedRowCount, setSelectedRowCount] = React.useState<number>(0);
  const [deleteConfirm, setDeleteConfirm] = React.useState(false);
  const [edit, setEdit] = React.useState(false);
  const [editmanufacturerMutation, editmanufacturerMutationResult] =
    useEditManufacturerMutation();
  const [deleteMutation, deleteMutationResult] =
    useDeleteManufacturerMutation();
  const [Formopen, setFormOpen] = React.useState(false);
  const [imagePopupOpen, setImagePopupOpen] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [manufacturers, setManufacturers] = React.useState<
    CatalogManufacturerResponse[]
  >([]);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const ManufacturerInitialValues: ProductManufacturer = {
    id: selectedRow?.id || "",
    title: selectedRow?.title || "",
    shortTitle: selectedRow?.shortTitle || "",
    commonMfgId: selectedRow?.commonMfgId,
  };
  const open = Boolean(anchorEl);
  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    item: CatalogManufacturerResponse
  ) => {
    setSelectedRowCount(item.productCount);
    setAnchorEl(event.currentTarget);
    setSelectedRow(item.manufacturer);
  };
  const handleClose = (params: any) => {
    setAnchorEl(null);
  };
  const handleOnSubmit = (values: ProductManufacturer) => {
    setErrorMessage("");
    if (edit) {
      editmanufacturerMutation({
        data: { id: selectedRow?.id, Manufacturer: values },
      }).then((res: any) => {
        if (res && res?.data) {
          if (res.data.status === 0) {
            refetch();
            setEdit(false);
            handleFormClose();
          } else if (res.data.status === 6) {
            setErrorMessage("This manufacturer already exists.");
            return;
          } else {
            setErrorMessage("Failed to update manufacturer.");
          }
        }
      });
    } else {
      manufacturerMutation({ data: { ...values, id: undefined } }).then(
        (res: any) => {
          if (res && res?.data) {
            if (res.data.status === 0) {
              refetch();
              handleFormClose();
            } else {
              setErrorMessage("This manufacturer already exists.");
              return;
            }
          }
        }
      );
    }
  };

  const handleClickOpen = () => {
    setFormOpen(true);
  };

  const handleFormClose = () => {
    setFormOpen(false);
    setSelectedRow({ id: "", title: "", shortTitle: "" });
  };
  const onDeleteCategory = (item: ProductManufacturer) => {
    setDeleteConfirm(false);
    setManufacturers(
      manufacturers.filter((i) => i.manufacturer.id !== item.id)
    );
    deleteMutation({ data: { id: item.id } });
  };
  React.useEffect(() => {
    if (data && isSuccess) {
      setManufacturers(data.entityList ?? []);
    }
  }, [data]);

  const columns: GridColDef[] = [
    {
      field: "title",
      headerName: "Title",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            {params.row?.manufacturer?.imageUrl ? (
              <Box
                style={{
                  width: "50px",
                  height: "50px",
                  backgroundColor: "white",
                }}
              >
                <img
                  style={{ maxWidth: "100%", maxHeight: "100%" }}
                  alt=""
                  src={params.row?.manufacturer?.imageUrl}
                ></img>
              </Box>
            ) : (
              ""
            )}

            <Typography sx={{ cursor: "pointer" }} color="primary" pl={3}>
              {params.row.manufacturer.title}
            </Typography>
          </>
        );
      },
      valueGetter: (params: GridValueGetterParams) =>
        params.row.manufacturer.title,
    },
    {
      field: "shortTitle",
      headerName: "Short Title",
      flex: 1,
      valueGetter: (params: GridValueGetterParams) =>
        params.row.manufacturer.shortTitle,
    },
    {
      field: "productCount",
      headerName: "Product Count",
      flex: 1,
      align: "right",
      headerAlign: "right",
      filterable: false,
    },
    {
      field: "Common Mfg Id",
      headerName: "commonMfgId",
      flex: 1,
      align: "right",
      headerAlign: "right",
      filterable: false,
      valueGetter: (params: GridValueGetterParams) =>
        params.row.manufacturer.commonMfgId ?? "N/A",
    },
    {
      field: "actions",
      headerName: "Actions",
      type: "actions",
      width: 350,

      renderCell: (params: GridRenderCellParams) => {
        return (
          <div>
            <IconButton
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={(e) => {
                handleClick(e, params.row);
              }}
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              // onClose={}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem
                disabled={selectedRowCount > 0}
                onClick={() => {
                  handleClose(params);
                  setDeleteConfirm(true);
                }}
              >
                <ListItemIcon>
                  <DeleteIcon />
                </ListItemIcon>
                <ListItemText>Delete</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setEdit(true);
                  setFormOpen(true);
                  handleClose(params);
                }}
              >
                <ListItemIcon>
                  <EditIcon />
                </ListItemIcon>
                <ListItemText>Edit</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setImagePopupOpen(true);
                  handleClose(params);
                }}
              >
                <ListItemIcon>
                  <EditIcon />
                </ListItemIcon>
                <ListItemText>Add Image</ListItemText>
              </MenuItem>
            </Menu>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Container maxWidth={false}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
            Manufacturers
          </Typography>
          <Button
            variant="contained"
            onClick={() => {
              setEdit(false);
              handleClickOpen();
            }}
            startIcon={<AddIcon />}
          >
            Add New
          </Button>
        </Stack>

        <Box
          sx={{
            mt: 1,
            height: "76vh",
            width: "100%",
            backgroundColor: "white",
          }}
        >
          <DataGrid
            rows={manufacturers.map((mfr, index: number) => {
              return { ...mfr, id: index };
            })}
            columns={columns}
            checkboxSelection={false}
            disableSelectionOnClick
            disableColumnSelector
            disableDensitySelector
            loading={isLoading}
            rowsPerPageOptions={[10, 20, 50, 100]}
            components={{ Toolbar: GridToolbar }}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
          />
        </Box>
        <Dialog open={Formopen} onClose={handleFormClose}>
          <DialogTitle alignSelf={"center"}>
            {" "}
            {edit ? "Edit" : "Add"} Manufacturer
          </DialogTitle>
          <DialogContent>
            <Formik
              initialValues={ManufacturerInitialValues}
              validationSchema={ManufacturerValidationSchema}
              onSubmit={(values) => {
                handleOnSubmit(values);
              }}
              enableReinitialize={true}
            >
              {({
                values,
                errors,

                handleChange,
                handleBlur,
              }) => (
                <>
                  <Form>
                    <Grid
                      container
                      spacing={3}
                      justifyContent="space-between"
                      display="flex"
                      p={5}
                    >
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="title"
                          name="title"
                          label="Title"
                          fullWidth
                          autoComplete="family-name"
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.title}
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="title"
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="shortTitle"
                          name="shortTitle"
                          label="Short Title"
                          fullWidth
                          autoComplete="shipping address-line1"
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.shortTitle}
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="shortTitle"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          disabled
                          id="commonMfgId"
                          name="commonMfgId"
                          label="Common MfgId"
                          fullWidth
                          autoComplete="shipping address-line1"
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.commonMfgId}
                        />
                      </Grid>

                      <Grid item xs={12} mt={3}>
                        <Grid
                          container
                          direction="row"
                          justifyContent="space-between"
                          alignItems="flex-end"
                        >
                          <Grid item>
                            <Button
                              color="error"
                              variant="contained"
                              onClick={() => {
                                handleFormClose();
                              }}
                            >
                              Cancel
                            </Button>
                          </Grid>
                          <Grid item>
                            <Typography color="error">
                              {errorMessage}
                            </Typography>
                          </Grid>
                          <Grid item>
                            <Button
                              variant="contained"
                              type="submit"
                              endIcon={
                                editmanufacturerMutationResult.isLoading ||
                                manufacturerMutationResult.isLoading ? (
                                  <CircularProgress color="inherit" size={20} />
                                ) : (
                                  <></>
                                )
                              }
                              disabled={
                                editmanufacturerMutationResult.isLoading ||
                                manufacturerMutationResult.isLoading
                              }
                            >
                              Save
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Form>
                </>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
        <Dialog open={deleteConfirm} onClose={handleClose} fullWidth>
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            Confirm to delete
          </DialogTitle>
          <DialogContent>
            Are you sure to delete the Manufacturer?
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              onClick={() => {
                setDeleteConfirm(false);
              }}
            >
              No
            </Button>
            <Button
              onClick={() => {
                if (selectedRow) onDeleteCategory(selectedRow);
              }}
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        <ManufacturerImageDialog
          isOpen={imagePopupOpen}
          onClose={() => setImagePopupOpen(false)}
          manufacturer={selectedRow}
          refetch={refetch}
        ></ManufacturerImageDialog>
      </Container>
    </>
  );
};
